/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDeviceRequest
 */
export interface CreateDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    platform: CreateDeviceRequestPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    osVersion: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    appVersion: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    webviewVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeviceRequest
     */
    nativeVersion?: string;
}


/**
 * @export
 */
export const CreateDeviceRequestPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    Electron: 'electron',
    Web: 'web'
} as const;
export type CreateDeviceRequestPlatformEnum = typeof CreateDeviceRequestPlatformEnum[keyof typeof CreateDeviceRequestPlatformEnum];


/**
 * Check if a given object implements the CreateDeviceRequest interface.
 */
export function instanceOfCreateDeviceRequest(value: object): value is CreateDeviceRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('osVersion' in value) || value['osVersion'] === undefined) return false;
    if (!('appVersion' in value) || value['appVersion'] === undefined) return false;
    return true;
}

export function CreateDeviceRequestFromJSON(json: any): CreateDeviceRequest {
    return CreateDeviceRequestFromJSONTyped(json, false);
}

export function CreateDeviceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'platform': json['platform'],
        'model': json['model'],
        'osVersion': json['osVersion'],
        'appVersion': json['appVersion'],
        'webviewVersion': json['webviewVersion'] == null ? undefined : json['webviewVersion'],
        'nativeVersion': json['nativeVersion'] == null ? undefined : json['nativeVersion'],
    };
}

export function CreateDeviceRequestToJSON(json: any): CreateDeviceRequest {
    return CreateDeviceRequestToJSONTyped(json, false);
}

export function CreateDeviceRequestToJSONTyped(value?: CreateDeviceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'platform': value['platform'],
        'model': value['model'],
        'osVersion': value['osVersion'],
        'appVersion': value['appVersion'],
        'webviewVersion': value['webviewVersion'],
        'nativeVersion': value['nativeVersion'],
    };
}

